"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColoredButton = exports.ButtonColor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sdsButtons_1 = require("../sdsButtons");
const ColoredButton_module_css_1 = __importDefault(require("./ColoredButton.module.css"));
var ButtonColor;
(function (ButtonColor) {
    ButtonColor[ButtonColor["BLACK"] = 0] = "BLACK";
    ButtonColor[ButtonColor["GRAY"] = 1] = "GRAY";
    ButtonColor[ButtonColor["YELLOW"] = 2] = "YELLOW";
    ButtonColor[ButtonColor["BLUE"] = 3] = "BLUE";
    ButtonColor[ButtonColor["WHITE"] = 4] = "WHITE";
})(ButtonColor = exports.ButtonColor || (exports.ButtonColor = {}));
function getButtonClassName(color) {
    switch (color) {
        case ButtonColor.BLACK: {
            return ColoredButton_module_css_1.default.blackButton;
        }
        case ButtonColor.GRAY: {
            return ColoredButton_module_css_1.default.grayButton;
        }
        case ButtonColor.YELLOW: {
            return ColoredButton_module_css_1.default.yellowButton;
        }
        case ButtonColor.BLUE: {
            return ColoredButton_module_css_1.default.blueButton;
        }
        case ButtonColor.WHITE: {
            return ColoredButton_module_css_1.default.whiteButton;
        }
    }
}
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line jsdoc/require-jsdoc
function ColoredButton(props) {
    return (0, jsx_runtime_1.jsx)(sdsButtons_1.ButtonOrLink, { ...props, className: getButtonClassName(props.color) });
}
exports.ColoredButton = ColoredButton;
//# sourceMappingURL=ColoredButton.js.map